import React from 'react'
import PropTypes from 'prop-types'
import './Flash.css'

const InstagramDMFlash = ({ clearFlash, data, userKind }) => {
  return (
    <div className="flash instagram">
      <div className="message-content">
        <i className="fa fa-instagram instagram-flash-icon fa-2x" aria-hidden="true"></i>
        <span className="message-type">message</span>
        <span className="message-body">
          {(userKind !== "coach") && `${data.staff.name}: `}
          {`New Instagram DM from ${data.contact.title}`}
        </span>
      </div>
      <div className="line">
      </div>
      <i className="fa fa-times close-flash" onClick={clearFlash}></i>
    </div>
  )
}

InstagramDMFlash.propTypes = {
  data: PropTypes.object.isRequired,
}

export default InstagramDMFlash
